import ErrorMessage from '@/components/tx/ErrorMessage'

const WalletRejectionError = () => {
  return <ErrorMessage>User rejected signing.</ErrorMessage>
}

export default WalletRejectionError
